<template>
  <div class="section section-white">
    <el-form ref="form" :model="form" label-width="auto" label-position="left" class="demo-ruleForm">
      <template v-if="!isEditor || (isEditor && !form.item_main_cat_id)">
        <el-card shadow="never" header="选择主分类" v-loading="mainCateLoader">
          <el-cascader
            :options="mainCategory"
            v-model="selectedMainCategory"
            @change="handleCategoryChange"
            style="width: 360px;">
          </el-cascader>
        </el-card>
      </template>
      <div class="content-padded view-flex view-flex-middle" v-loading="loader" v-else>
        <div>主分类：</div>
        <el-breadcrumb separator-class="el-icon-arrow-right" class="inline">
          <el-breadcrumb-item v-for="(item, index) in categoryNames" :key="index">{{item}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <template v-if="(!isEditor && selectedMainCategory.length > 0) || isEditor">
        <el-card shadow="never" v-loading="loader">
          <div slot="header" class="clearfix">
            <span>基础信息</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="panelCollapse('base')"><i class="iconfont" :class="panel.base ? 'icon-window-minimize1': 'icon-plus'"></i></el-button>
          </div>
          <transition name="el-zoom-in-top">
            <div class="form-collapse" v-show="panel.base">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8">
                  <el-form-item label="*商品标题">
                    <el-input v-model="form.item_name" :maxlength="50" placeholder=""></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                  <el-form-item label="副标题">
                    <el-input v-model="form.brief" :maxlength="140" placeholder=""></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                  <el-form-item label="*商品通用名(药品)">
                    <el-input v-model="form.common_name" :maxlength="50" placeholder="请输入药品的通用名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                  <el-form-item label="*及时配送运费模板">
                    <el-select v-model="form.templates_id" placeholder="请选择">
                      <el-option v-for="item in templatesList" :key="item.template_id" :label="item.name" :value="item.template_id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                  <el-form-item label="*快递配送运费模板">
                    <el-select v-model="form.express_templates_id" placeholder="请选择">
                      <el-option v-for="item in templatesList" :key="item.template_id" :label="item.name" :value="item.template_id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                  <el-form-item label="*品牌">
                    <el-select v-model="form.brand_id" filterable placeholder="请选择">
                      <el-option
                        v-for="item in brandList"
                        :key="item.attribute_id"
                        :label="item.attribute_name"
                        :value="item.attribute_id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                  <el-form-item label="*计量单位">
                    <el-input v-model="form.item_unit" :maxlength="60" placeholder=""></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                  <el-form-item label="排序编号">
                    <el-input v-model="form.sort" placeholder=""></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                  <el-form-item label="*商品分类">
                    <treeselect
                      :options="categoryList"
                      :show-count="true"
                      :multiple="true"
                      :disable-branch-nodes="false"
                      :flat="true"
                      v-model="form.item_category"
                    >
                    </treeselect>
                    <!-- <el-select
                            v-model="form.item_category"
                            multiple
                            filterable
                            default-first-option
                            placeholder="请选择商品分类">
                      <el-option
                              v-for="item in categoryList"
                              :key="item.category_id"
                              :label="item.label"
                              :value="item.value">
                      </el-option>
                    </el-select> -->
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                  <el-form-item label="产地">
                    <el-cascader
                      placeholder="选择地区"
                      :options="regions"
                      v-model='select_regions_value'
                      @change="regionChange">
                    </el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                  <el-form-item label="*生产厂家">
                    <el-input v-model="form.producer" :maxlength="60" placeholder=""></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                  <el-form-item label="*国药准字号">
                    <el-input v-model="form.Reg_No_" :maxlength="60" placeholder=""></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                  <el-form-item label="*商品规格">
                    <el-input v-model="form.spec" :maxlength="60" placeholder=""></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                  <el-form-item label="*计量单位转换系数">
                    <el-input v-model="form.unit_zhuan_huan_value" :maxlength="10" placeholder=""></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                  <el-form-item label="*商品关键词">
                    <el-input v-model="form.keywords" :maxlength="255" placeholder="请输入商品关键词（如：商品标题|关键词1|关键词2...）"></el-input>
                    <div class="frm-tips">
                      <p>1. 商品关键词规则：商品标题|关键词1|关键词2|关键词3</p>
                      <p>2. 请务必将商品标题放在关键词首位</p>
                      <p>3. 注意在修改商品标题时，请修改关键词内对应的商品标题</p>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                  <el-form-item label="是否支持医保支付" prop="is_yibao">
                    <el-radio-group v-model="form.is_yibao">
                      <el-radio :label="1" >是</el-radio>
                      <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :xs="24">
                  <el-form-item label="*商品图">
                    <div>
                      <div class="pics-box">
                        <ul class="goodspic-wrap">
                          <draggable v-model="form.pics" :options="dragIssuesOptions" class="components-view">
                            <li v-for="(item, index) in form.pics" :key='index' class="goodspic" @mouseenter="picsEnter(index)" @mouseleave="picsLeave">
                              <!-- <img :src="wximageurl + item" /> -->
                              <el-image
                                ref="imageRef"
                                :src="wximageurl + item"
                                show-progress
                                :preview-src-list="form.pics"
                                fit="cover"
                              />
                              <div class="goodspic-mask" :class="(picsCurrent == index) ? 'on' : ''">
                                <div class="iconfont icon-trash-alt" @click="removePicsImg(index)"></div>
                                <div class="iconfont icon-arrows-alt"></div>
                                <div @click="handlePreview(index)" class="iconfont icon-eye"></div>
                              </div>
                            </li>
                          </draggable>
                        </ul>
                        <div v-if="form.pics.length < 9" class="upload-box" @click="handlePicsChange">
                          <i class="iconfont icon-camera"></i>
                        </div>
                      </div>
                      <div class="frm-tips">
                        <p>1. 最多可上传9个图片，文件格式为bmp、png、jpeg、jpg或gif，大小不超过2M（建议尺寸：500px * 500px）</p>
                        <p>2. 拖动图片进行可排序</p>
                      </div>
                    </div>
                    <imgPicker :dialog-visible="picsDialog" :sc-status="isGetPics" :is-most="multiple" @chooseImg="pickPics" @closeImgDialog="closePicsDialog"></imgPicker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24">
                  <el-form-item label="上传视频">
                    <videoPicker :data="itemVideo" @change="pickVideo"></videoPicker>
                    <el-button v-if="itemVideo.media_id" @click="deleteVideo" type="text">删除</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </transition>
          <el-form-item label="商品属性">
              <el-select size="small" v-model="form.items_attr"  placeholder="商品属性" >
                <el-option
                        placeholder="商品属性"
                        v-for="(item,index) in itemsAttrArr"
                        :key="index"
                        :label="item"
                        :value="index">
                </el-option>
              </el-select>
           </el-form-item>
            <el-form-item label="商品属性范围">
          <el-select size="small" v-model="form.items_scope"  placeholder="商品属性范围">
            <el-option
                    placeholder="商品属性范围"
                    v-for="(item,index) in itemsScopeArr"
                    :key="index"
                    :label="item"
                    :value="index">
            </el-option>
          </el-select>
             </el-form-item>
        </el-card>
        <el-card shadow="never" v-loading="loader">
          <div slot="header" class="clearfix">
            <span>* 是否特殊商品类型</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="panelCollapse('goods_type')"><i class="iconfont" :class="panel.goods_type ? 'icon-window-minimize1': 'icon-plus'"></i></el-button>
          </div>
          <el-radio-group v-model="form.special_type">
            <el-radio label="normal">普通商品</el-radio>
            <el-radio label="drug">处方药</el-radio>
          </el-radio-group>

        </el-card>
        <el-card shadow="never" v-loading="loader">
          <div slot="header" class="clearfix">
            <span>商品参数</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="panelCollapse('param')"><i class="iconfont" :class="panel.param ? 'icon-window-minimize1': 'icon-plus'"></i></el-button>
          </div>
          <transition name="el-zoom-in-top">
            <div class="form-collapse" v-show="panel.param">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="(item, index) in params" :key="index">
                  <el-form-item :label="item.label">
                    <el-select v-if="item.children.length > 0" v-model="form.item_params[index].attribute_value_id" placeholder="请选择">
                      <el-option
                        v-for="child in item.children"
                        :key="child.value"
                        :label="child.label"
                        :value="child.value">
                      </el-option>
                    </el-select>
                    <el-input v-else v-model="form.item_params[index].attribute_value_name" :maxlength="60" placeholder=""></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </transition>
        </el-card>
        <el-card shadow="never" v-loading="loader">
          <div slot="header" class="view-flex">
            <div class="view-flex-item">商品规格</div>
            <template v-if="!isEditor">
              <span class="small mark" v-if="skus.length === 0">添加多规格商品请先为当前主类目绑定规格!</span>
              <template v-if="skus.length > 0">
                <el-switch
                  style="margin-left: 30px;"
                  v-model="form.nospec"
                  active-color="#13ce66"
                  inactive-color="#efefef"
                  active-text="统一规格"
                  inactive-text="多规格">
                </el-switch>
              </template>
            </template>
            <template v-if="!form.nospec">
              <span style="margin-left: 30px;">
                <span style="margin-right: 10px;">是否在商详页成列图片规格</span>
                <el-switch
                  v-model="form.is_show_specimg"
                  active-color="#13ce66"
                  inactive-color="#efefef">
                </el-switch>
              </span>
            </template>
          </div>
          <template v-if="form.nospec">
            <el-row :gutter="20">
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item label="*商品状态" :render-header="renderRequire">
                  <el-select v-model="form.approve_status" placeholder="请选择">
                    <el-option
                      v-for="item in statusOption"
                      :key="item.value"
                      :label="item.title"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item label="*库存">
                  <el-input type="number" required min="0" v-model="form.store" placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item label="*商品货号">
                  <el-input v-model="form.item_bn" :maxlength="60" placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item label="重量">
                  <el-input type="number" required min="0" v-model="form.weight" placeholder=""><template slot="append">g</template></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item label="体积">
                  <el-input type="number" required min="0" v-model="form.volume" placeholder=""><template slot="append">m³</template></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item label="*销售价">
                  <el-input type="number" required min="0" v-model="form.price" @blur="EditPrice(form.price)" placeholder=""><template slot="prepend">¥</template></el-input>
                </el-form-item>
                <div class="frm-tips">
                  <el-tag v-if="(only_show_price_low!='0')||(only_show_price_high!='0')">
                    ￥{{only_show_price_low/100}} - {{only_show_price_high/100}}
                  </el-tag>
                </div>
                <el-collapse >
                  <el-collapse-item title="修改价格不会作用到下列店铺 " name="1">
                    <div v-for="(distritors_prics,key,value) in distributors_prices_arr">
                      店铺id {{key.split('_')[1]}}  价格:￥{{distritors_prics/100}}
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item label="成本价">
                  <el-input type="number" required min="0" v-model="form.cost_price" placeholder=""><template slot="prepend">¥</template></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item label="*原价">
                  <el-input type="number" required min="0" v-model="form.market_price" placeholder=""><template slot="prepend">¥</template></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item label="条形码">
                  <el-input type="number" required min="0" v-model="form.barcode" placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item label="打包费">
                  <el-input type="number" required min="0" v-model="form.packing_fee" placeholder=""><template slot="prepend">¥</template></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
          <template v-else >
            <el-card v-for="(item, index) in skus" :key="item.index">
              <div class="sku-select__item">
                <div class="goods">
                  {{item.sku_name}}：
                </div>
                <div class="sku-select__checkgroup">
                  <el-checkbox-group v-model="item.checked_sku" @change="handleSkuChange">
                    <template v-for="(value, vn) in item.sku_value">
                      <div class="sku-select__checkitem">
                        <imgBox v-if="value.image_url" :imgUrl="value.image_url" width="50" height="50" />
                        <el-checkbox :label="value.attribute_value_id">
                          <el-input v-if="item.checked_sku.indexOf(value.attribute_value_id) !== -1" v-model="value.custom_attribute_value" size="mini" style="width: 100px;" @change="handleSkuName(value.custom_attribute_value, value.attribute_value_id)"></el-input>
                          <span v-else>{{value.attribute_value}}</span>
                        </el-checkbox>
                      </div>
                    </template>
                  </el-checkbox-group>
                </div>
              </div>
            </el-card>
            <div v-if="specImages.length > 0" class="content-bottom-padded">
              <div class="content-padded h3">设置规格图片</div>
              <el-table
                :data="specImages"
                :header-cell-style="{background:'#f5f7fa'}">
                <el-table-column label="规格" prop="item_spec" width="240">
                </el-table-column>
                <el-table-column label="规格图">
                  <template slot-scope="scope">
                    <imgBox v-for="(item, index) in scope.row.item_image_url" :key="index" :imgUrl="item" inline removeBtn width="50" height="50" @remove="handleImgRemove(scope.$index, index)"></imgBox>
                    <imgBox v-if="scope.row.item_image_url.length < 5" width="50" height="50" inline @click="handleSkuImg(scope.$index)"></imgBox>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="content-padded h3">设置规格</div>
            <el-table
              :data="bulkFilling"
              :show-header="false"
              :highlight-current-row="false">
              <el-table-column>
                <template slot-scope="scope">
                  {{scope.row.custom_attribute_value || scope.row.item_spec}}
                </template>
              </el-table-column>
              <el-table-column label="*状态">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.approve_status" size="mini" placeholder="请选择">
                    <el-option
                      v-for="item in statusOption"
                      :key="item.value"
                      :label="item.title"
                      size="mini"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="库存">
                <template slot-scope="scope">
                  <el-input type="number" required min="0" v-model="scope.row.store" size="mini" placeholder=""></el-input>
                </template>
              </el-table-column>
              <el-table-column label="货号">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.item_bn" :maxlength="60" size="mini" placeholder=""></el-input>
                </template>
              </el-table-column>
              <el-table-column label="重量">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.weight" :maxlength="60" size="mini" placeholder=""></el-input>
                </template>
              </el-table-column>
              <el-table-column label="体积">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.volume" :maxlength="60" size="mini" placeholder=""></el-input>
                </template>
              </el-table-column>
              <el-table-column label="销售价">
                <template slot-scope="scope">
                  <el-input type="number" required min="0" v-model="scope.row.price" size="mini" placeholder=""></el-input>
                </template>
              </el-table-column>
              <el-table-column label="成本价">
                <template slot-scope="scope">
                  <el-input type="number" required min="0" v-model="scope.row.cost_price" size="mini" placeholder=""></el-input>
                </template>
              </el-table-column>
              <el-table-column label="原价">
                <template slot-scope="scope">
                  <el-input type="number" required min="0" v-model="scope.row.market_price" size="mini" placeholder=""></el-input>
                </template>
              </el-table-column>
              <el-table-column label="条形码">
                <template slot-scope="scope">
                  <el-input type="number" required min="0" v-model="scope.row.barcode" size="mini" placeholder=""></el-input>
                </template>
              </el-table-column>
                 <el-table-column label="打包费">
                <template slot-scope="scope">
                  <el-input type="number" required min="0" v-model="scope.row.packing_fee" size="mini" placeholder=""></el-input>
                </template>
              </el-table-column>
              <el-table-column width="80">
                <template slot-scope="scope">
                  <el-button type="primary" @click="fillSku" size="mini">填充</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-table
              :data="specItems[currentPage-1]"
              :header-cell-style="{background:'#f5f7fa'}"
              style="width: 100%">
              <el-table-column label="规格值">
                <template slot-scope="scope">
                  <span v-for="item in scope.row.item_spec">
                    {{item.spec_custom_value_name || item.spec_value_name}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="状态" :render-header="renderRequire">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.approve_status" size="mini" placeholder="请选择" @change="upadateState(scope.row)">
                    <el-option
                      v-for="item in statusOption"
                      :key="item.value"
                      :label="item.title"
                      size="mini"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="库存" :render-header="renderRequire">
                <template slot-scope="scope">
                  <el-input type="number" required min="0" v-model="scope.row.store" size="mini" placeholder="" @change="upadateState(scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="货号">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.item_bn" :maxlength="60" size="mini" placeholder="" @change="upadateState(scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="重量(g)">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.weight" :maxlength="60" size="mini" placeholder="" @change="upadateState(scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="体积(m³)">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.volume" :maxlength="60" size="mini" placeholder="" @change="upadateState(scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="销售价" :render-header="renderRequire">
                <template slot-scope="scope">
                  <el-input type="number" required min="0" v-model="scope.row.price" size="mini" placeholder="" @change="upadateState(scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="成本价">
                <template slot-scope="scope">
                  <el-input type="number" required min="0" v-model="scope.row.cost_price" size="mini" placeholder="" @change="upadateState(scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="原价">
                <template slot-scope="scope">
                  <el-input type="number" required min="0" v-model="scope.row.market_price" size="mini" placeholder="" @change="upadateState(scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="条形码">
                <template slot-scope="scope">
                  <el-input type="number" required min="0" v-model="scope.row.barcode" size="mini" placeholder="" @change="upadateState(scope.row)"></el-input>
                </template>
              </el-table-column>
                <el-table-column label="打包费">
                <template slot-scope="scope">
                  <el-input type="number" required min="0" v-model="scope.row.packing_fee" size="mini" placeholder="" @change="upadateState(scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column width="80">
                <template slot-scope="scope">
                  <el-button type="text" @click="clearSku(scope.$index)">清除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="content-center content-top-padded">
              <el-pagination
                :current-page="currentPage"
                :page-size="specPagesize"
                layout="prev, pager, next"
                @current-change="pageChange"
                :total="specTotal">
              </el-pagination>
            </div>
          </template>
        </el-card>
      <el-card shadow="never" v-loading="loader">
       <div slot="header" class="clearfix">
         <span>服务类商品</span>
         <el-button style="float: right; padding: 3px 0" type="text" @click="panelCollapse('goods_type')"><i class="iconfont" :class="panel.goods_type ? 'icon-window-minimize1': 'icon-plus'"></i></el-button>
       </div>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="入住商品" prop="is_settle_in">
              <el-radio-group v-model="form.is_settle_in">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="form.is_settle_in == true" label="服务商品" prop="is_settle_in_service">
              <el-radio-group v-model="form.is_settle_in_service">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="form.is_settle_in_service == true && form.is_settle_in == true" label="服务费" prop="si_charging_method">
              <el-radio-group v-model="form.si_charging_method">
                <el-radio label="rate" >费率</el-radio>
                <el-radio label="fixed_costs">固定费用</el-radio>
              </el-radio-group>
              <br>
            </el-form-item>
            <el-form-item label="费率（百分比）" v-if="form.si_charging_method == 'rate' && form.is_settle_in_service ==true && form.is_settle_in ==true" prop="si_rate">
              <el-input v-model="form.si_rate" style="width: 220px;" placeholder="百分比" maxlength=4 minlength=4></el-input>
            </el-form-item>
            <el-form-item label="固定费用（元）" v-if="form.si_charging_method == 'fixed_costs' && form.is_settle_in_service ==true && form.is_settle_in ==true" prop="si_fixed_costs">
              <el-input v-model="form.si_fixed_costs" style="width: 220px;" placeholder="元" maxlength=4 minlength=4></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="商品库存是否从NP取" prop="is_NP_store">
              <el-radio-group v-model="form.is_NP_store">
                <el-radio :label="true" >是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card shadow="never" v-loading="loader">
        <div slot="header" class="clearfix">
          <span>中药产品</span>
          <el-button style="float: right; padding: 3px 0" type="text" @click="panelCollapse('param')"><i class="iconfont" :class="panel.param ? 'icon-window-minimize1': 'icon-plus'"></i></el-button>
        </div>
        <transition name="el-zoom-in-top">
          <div class="form-collapse" v-show="panel.param">
            <el-row :gutter="20">
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item label="是否报销" prop="is_apply">
                  <el-radio-group v-model="form.is_apply">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </transition>
      </el-card>
      <el-card header="图文详情" shadow="never" v-loading="loader">
        <el-form-item label="模式">
          <el-radio-group v-model="mode">
            <el-radio :label="'richText'">富文本</el-radio>
            <el-radio :label="'component'">组件式</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="mode === 'richText'">
          <vue-html5-editor :content="form.intro" ref="editor" @change="updateContent" :height="360"></vue-html5-editor>
          <span class="tpl_item img" @click="addImgPreview" style="">
            <i class="iconfont icon-image"></i>图片
          </span>
        </template>
        <template v-else>
          <richTextEditor :data="content" :control="['film','slider','heading','writing']" @change="handleContent"/>
        </template>
        <imgPicker :dialog-visible="thumbDialog" :sc-status="isGetThumb" :isMost="true" @chooseImg="pickThumb" @closeImgDialog="closeThumbDialog"></imgPicker>
      </el-card>

        <div class="section-footer with-border content-center">
          <el-button @click.native="handleCancel">取消</el-button>
          <el-button type="primary" @click="submitItemsActionConfirm" :loading="submitLoading">{{submitLoading ? '提交中' : '保存'}}</el-button>
        </div>
      </template>
    </el-form>
  </div>
</template>

<script>
  import store from '@/store'
  import { mapGetters } from 'vuex'
  // import the component
  import Treeselect from '@riophae/vue-treeselect'
  import draggable from 'vuedraggable'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import { getItemsDetail, createItems, updateItems, getCategory, getGoodsAttr, getCategoryInfo ,
  getItemsAttrList,
  getItemsScopeList
  } from '@/api/goods'
  import { getShippingTemplatesList } from '@/api/shipping'
  import { uploadMaterial } from '@/api/wechat'
  import imgPicker from '@/components/imageselect'
  import videoPicker from '@/components/videoselect'
  import richTextEditor from '@/components/function/richTextEditor'
  import imgBox from '@/components/element/imgBox'
  import district from '@/common/district.json'

  export default {
    inject: ['refresh'],
    components: {
      imgPicker,
      videoPicker,
      Treeselect,
      draggable,
      richTextEditor,
      imgBox,
    },
    data() {
      return {
        itemVideo: {},
        select_regions_value: [],
        regions: district,
        mainCategory: [],
        selectedMainCategory: [],
        categoryNames: [],
        mainCateLoader: false,
        loader: true,
        submitLoading: false,
        isEditor: false,
        isLeave: false,
        panel: {
          base: true,
          param: true,
          goods_type: true,
        },
        is_new: false,
        isGetImage: false,
        imgDialog: false,
        isGetVideo: false,
        statusOption: [
          {
            title: '前台可销售',
            value: 'onsale'
          },
          {
            title: '可线下销售',
            value: 'offline_sale'
          },
          {
            title: '前台仅展示',
            value: 'only_show'
          },
          {
            title: '不可销售',
            value: 'instock'
          }
        ],
        categoryList: [],
        brandList: [],
        content: [],
        dragIssuesOptions: {
          animation: 300,
          forceFallback: true,
          scroll: true,
          handle: '.icon-arrows-alt',
          draggable: '.goodspic'
        },
        form: {
          item_id: '',
          item_type: 'normal',
          special_type: '',
          item_source: 'mall',
          item_category: [],
          item_params: [],
          item_name: '',
          common_name: '',
          sort: 0,
          item_bn: '',
          producer: '',
          Reg_No_: '',
          unit_zhuan_huan_value: '',
          spec: '',
          brief: '',
          weight: '',
          volume: '',
          price: '',
          market_price: '',
          cost_price: 0,
          packing_fee: 0,
          barcode: '',
          item_unit: '',
          rebate: '',
          store: '',
          brand_id: '',
          templates_id: '',
          express_templates_id: '',
          approve_status: 'onsale',
          intro: '',
          pics: [],
          videos: '',
          videos_url: '',
          nospec: true,
          is_show_specimg: false,
          spec_images: [],
          spec_items: [],
          item_main_cat_id: '',
          is_settle_in:false,
          is_NP_store:false,
          is_yibao:0,
          is_apply:false,
          is_settle_in_service:false,
          si_charging_method:'rate',
          si_rate:0,
          si_fixed_costs:0,
          keywords:'',
          items_attr:'',
          items_scope:'',
          vip_flag:false
        },
        bulkFilling: [{
          item_spec: '批量填充(货号最后一位从0自动追加)',
          approve_status: '',
          store: '',
          item_bn: '',
          item_unit: '',
          price: '',
          cost_price: '',
          market_price: '',
          packing_fee: '',
          barcode: ''
        }],
        bulkFilling_index:'0',
        specPagesize: 10,
        specTotal: 0,
        specImages: [],
        specItems: [],
        templatesList: [],
        picsList: [],
        params: [],
        skus: [],
        templatesListParams: {
          page: 1,
          pageSize: 99
        },
        dialogVisible: false,
        dialogImageUrl: '',
        thumbDialog: false,
        isGetThumb: false,
        isGetPics: false,
        picsDialog: false,
        picsCurrent: -1,
        picsOldLen: 0,
        currentSku: -1,
        currentPage: 1,
        multiple: false,
        mode: 'richText',
        // 修改前价格
        originalPrice:0,
        only_show_price_low:'',
        only_show_price_high:'',
        distributors_prices_arr:[],
        itemsScopeArr:[],
        itemsAttrArr:[],
      }
    },
    computed: {
      ...mapGetters([
        'editingSkus'
      ])
    },
    methods: {
      handlePreview(idx) {
        console.log(this.$refs.imageRef)
        if (this.$refs.imageRef) {
          // 找到组件内部的 img 元素并触发点击
          console.log(this.$refs.imageRef[idx].$el);
          const imgElement = this.$refs.imageRef[idx].$el.querySelector('img');
          if (imgElement) {
            imgElement.click();
          }
        }
        // this.$nextTick(() => {
        // 通过选择器找到页面中第一个 el-image 的预览触发器
        //   const previewTrigger = document.querySelector('.el-image__preview');
        //   if (previewTrigger) {
        //     previewTrigger.click();
        //   } else {
        //     console.warn('无法找到预览触发器');
        //     // 如果以上方法都不行，使用方法二
        //   }
        // });
        // 通过 $refs 找到图片组件，并模拟点击动作以触发预览
      },
      getItemsAttrLists(){
          getItemsAttrList().then(res=>{
              this.itemsAttrArr=res.data.data
          })
      },
      getItemsScopeLists(){
          getItemsScopeList().then(res=>{
              this.itemsScopeArr=res.data.data
          })
      },
      regionChange() {
        this.form.regions_id = this.select_regions_value
        this.form.item_address_province = this.select_regions_value[0]
        this.form.item_address_city = this.select_regions_value[1]
      },
      fetchMainCate() {
        getCategory({is_main_category: true}).then(res => {
          this.mainCategory = res.data.data
          this.mainCateLoader = false
        })
      },
      handleCategoryChange(val) {
        getCategoryInfo(val[val.length-1]).then(res => {
          let detail = res.data.data
          this.generateParams(detail.goods_params)
          this.generateSpec(detail.goods_spec)
        })
      },
      shopTypeChange (val) {
          this.zdShopHidden = true
          if (val === "false") {
              this.zdShopHidden = false
          }
      },
      // shopTypeChangee (val) {
      //     this.zdShopHiddenn = true
      //     if (val === "false") {
      //         this.zdShopHiddenn = false
      //     }
      // },
      generateParams(data) {
        let params = []
        let formParams = []
        data.forEach(item => {
          let key = {
            value: item.attribute_id,
            label: item.attribute_name,
            children: []
          }
          item.attribute_values.list.forEach(child => {
            let val = {
              value: child.attribute_value_id,
              label: child.attribute_value
            }
            key.children.push(val)
          })
          params.push(key)
          let selected = this.form.item_params.find(n => item.attribute_id === n.attribute_id)
          formParams.push({
            attribute_id: item.attribute_id,
            attribute_value_id: selected ? selected.attribute_value_id : '',
            attribute_value_name: selected ? selected.attribute_value_name : ''
          })
        })
        this.params = params
        this.form.item_params = formParams
      },
      handleSkuName (val, id) {
          console.log('vvvvv',val,'xxx',id)
        this.specItems.forEach(item => {
          item.forEach(child => {
            if (child.sku_id.indexOf(id) !== -1) {
                console.log('====')
                console.log(child.item_spec)
                child.item_spec.forEach( cchild=>{
                    console.log('xxxx')
                    console.log(cchild)
                    if(cchild.spec_value_id == id){
                        cchild.spec_custom_value_name = val
                    }
                })
              // child.item_spec[0].spec_custom_value_name = val
              store.dispatch('setSku', child)
              this.updateSku()
            }
          })
        })
      },
      generateSpec(data) {
        let skus = []
        data.forEach(item => {
          let specs = []
          item.attribute_values.list.forEach(spec => {
            if (!spec.custom_attribute_value) {
              Object.assign(spec, {custom_attribute_value: spec.attribute_value})
            }
            specs.push(spec)
          })
          let sku = {
            sku_id: item.attribute_id,
            sku_name: item.attribute_name,
            is_image: item.is_image,
            sku_value: specs,
            checked_sku: []
          }
          skus.push(sku)
        })
        this.skus = skus
      },
      upadateState(data) {
        store.dispatch('setSku', data)
      },
      EditPrice(data) {
        if(this.originalPrice>0)
        {
          let edit = Math.round(data/this.originalPrice * Math.pow(10,2)) / Math.pow(10,2)
          if(Number(edit*100)<=80)
          {
            this.$confirm('当前价格下调幅度大于等于20%，是否保存？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then((res) => {

            }).catch(() => {
              return
            })
          }
        }

      },
      panelCollapse(name) {
        this.panel[name] = !this.panel[name]
      },
      handleImgRemove(parent, index) {
        this.specImages[parent].item_image_url.splice(index, 1)
      },
      submitItemsAction: function () { // 提交商品
        if (+this.form.market_price < +this.form.rebate) {
          this.$confirm('当前店铺佣金大于商品原价, 是否继续保存?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then((res) => {
            this.submitItemsActionConfirm()
          }).catch(() => {
            return
          })
        } else {
          this.submitItemsActionConfirm()
        }
      },
      submitItemsActionConfirm() {
        this.submitLoading = true
        const that = this
        let formSkuItem = this.editingSkus
        // this.specItems.forEach(item => {
        //   item.forEach(child => {
        //     formSkuItem.push(child)
        //   })
        // })
        if (this.mode === 'component') {
          this.form.intro = JSON.stringify(this.content)
        }
        if (this.selectedMainCategory.length > 0) {
          this.form.item_main_cat_id = this.selectedMainCategory[this.selectedMainCategory.length-1]
        }
        if (!this.form.nospec) {
          if (formSkuItem.length > 0) {
            formSkuItem[0].is_default = true
          } else {
            this.submitLoading = false
            this.$message({message: '请设置规格信息', type: "error"})
            return
          }
        }
        if (!this.form.item_name) {
          this.$message({message: '请设置商品名称'})
          this.submitLoading = false
          return
        }
        if (!this.form.common_name) {
          this.$message({message: '请设置药品通用名'})
          this.submitLoading = false
          return
        }
        if (!this.form.templates_id) {
          this.$message({message: '请设置及时配送运费模板'})
          this.submitLoading = false
          return
        }
        if (!this.form.express_templates_id) {
          this.$message({message: '请设置快递配送运费模板'})
          this.submitLoading = false
          return
        }
        if (!this.form.brand_id) {
          this.$message({message: '请设置品牌'})
          this.submitLoading = false
          return
        }
        if (this.form.item_category.length < 1) {
          this.$message({message: '请设置商品分类'})
          this.submitLoading = false
          return
        }
        if (!this.form.item_unit) {
          this.$message({message: '请设置计量单位'})
          this.submitLoading = false
          return
        }
        if (!this.form.producer) {
          this.$message({message: '请设置生产厂家'})
          this.submitLoading = false
          return
        }
        if (!this.form.Reg_No_) {
          this.$message({message: '请设置国药准字号'})
          this.submitLoading = false
          return
        }
        if (!this.form.spec) {
          this.$message({message: '请设置商品规格'})
          this.submitLoading = false
          return
        }
        if (!this.form.unit_zhuan_huan_value) {
          this.$message({message: '请设置计量单位转换系数'})
          this.submitLoading = false
          return
        }
        if (!this.form.keywords) {
          this.$message({message: '请设置商品关键词'})
          this.submitLoading = false
          return
        }
        if (this.form.pics.length < 1) {
          this.$message({message: '请设置商品图片'})
          this.submitLoading = false
          return
        }
        if (!this.form.special_type) {
          this.$message({message: '请指明商品是否为处方药'})
          this.submitLoading = false
          return
        }
        if (!this.form.special_type) {
          this.$message({message: '请设置药品类型'})
          this.submitLoading = false
          return
        }
        if (!this.form.store) {
          this.$message({message: '请设置商品库存'})
          this.submitLoading = false
          return
        }
        // 非多规格商品检测是否设置货号
        if (this.form.nospec && !this.form.item_bn) {
          this.$message({message: '请设置商品货号'})
          this.submitLoading = false
          return
        }
        if (!this.form.price) {
          this.$message({message: '请设置商品销售价'})
          this.submitLoading = false
          return
        }
        if (!this.form.market_price) {
          this.$message({message: '请设置商品原价'})
          this.submitLoading = false
          return
        }
        this.form.spec_images = JSON.stringify(this.specImages)
        this.form.spec_items = JSON.stringify(formSkuItem)
        this.form.weight = this.form.weight/1000
        if (this.form.item_id && !this.is_new) {
          updateItems(this.form.item_id, this.form).then(response => {
            this.$message({
              message: '更新成功',
              type: 'success',
              duration: 2 * 1000,
              onClose () {
                that.submitLoading = false
                that.refresh()
                that.isLeave = true
                that.$router.go(-1)
              }
            })
          }).catch(error => {
            this.submitLoading = false
          })
        } else {
          createItems(this.form).then(response => {
            this.$message({
              message: '添加成功',
              type: 'success',
              duration: 2 * 1000,
              onClose () {
                that.submitLoading = false
                that.refresh()
                that.isLeave = true
                that.$router.go(-1)
              }
            })
          }).catch(error => {
            this.submitLoading = false
          })
        }
      },
      updateContent: function (data) {
        this.form.intro = data
      },
      handleCancel: function () {
        this.$router.go(-1)
      },
      pageChange(val) {
        this.currentPage = val
      },
      // 详情中的上传图片
      addImgPreview: function () {
        this.thumbDialog = true
        this.isGetThumb = true
      },
      pickThumb: function (arr) {
        if (arr.length != 0) {
          arr.forEach(data => {
            if (data && data.url !== '') {
              this.thumbDialog = false
              var index = this.$refs.editor.$el.id
              var loc = this.$refs.editor
              var img = new Image()
              img.src = this.wximageurl + data.url
              if (loc.range) {
                loc.range.insertNode(img)
                var referenceNode = loc.range.endContainer
                if (referenceNode.className !== 'content') {
                  loc.range.setStartAfter(referenceNode)
                } else {
                  loc.range.setStart(loc.range.endContainer, loc.range.endOffset)
                }
              } else {
                loc.$refs.content.appendChild(img)
                loc.focus()
                loc.restoreSelection()
              }
              this.form.intro = loc.$refs.content.innerHTML
            }
          })
        }
      },
      closeThumbDialog: function () {
        this.thumbDialog = false
      },
      //品牌LOGO
      handleImgChange () {
        this.imgDialog = true
        this.isGetImage = true
      },
      closeImgDialog () {
        this.imgDialog = false
      },
      //视频
      pickVideo (data) {
        this.form.videos = data.media_id
        this.form.videos_url = data.url
      },
      //上传商品图（9张）
      handlePicsChange: function () {
        this.picsDialog = true
        this.isGetPics = true
        this.multiple = true
      },
      handleSkuImg(index) {
        this.currentSku = index
        this.picsDialog = true
        this.isGetPics = true
        this.multiple = true
      },
      pickPics (data) {
        if (this.currentSku === -1) {
          if (this.picsOldLen + data.length >= 10) {
            this.$message.error('最多上传9张图片!')
            return false
          }else {
            if (data.length != 0) {
              data.forEach(data => {
                if (data && data.url !== '') {
                  this.form.pics.push(data.url)
                  this.picsOldLen = this.form.pics.length
                }
              })
            }
          }
        } else {
          if (this.specImages[this.currentSku].item_image_url.length + data.length > 5) {
            this.$message.error('最多添加5张图片!')
            return false
          }
          if (data.length > 0) {
            data.forEach(data => {
              if (data && data.url !== '') {
                this.specImages[this.currentSku].item_image_url.push(data.url)
              }
            })
          }
          this.currentSku = -1
        }
        this.picsDialog = false
      },
      fillSku() {
        let obj = {...this.bulkFilling[0]}
        let newObj = {}
        for (let key in obj) {
          if (obj[key] && key !== 'item_spec') {
            newObj[key] = obj[key]
          }
        }
        let list = [...this.specItems[this.currentPage-1]]
        // 批量填充货号值 +1
          list.forEach(item => {
              Object.assign(item, newObj)
              item.item_bn = newObj.item_bn + Number(this.bulkFilling_index);
              this.bulkFilling_index ++ ;
          })
          store.dispatch('setPage', list)

          // let lastnum = newObj.item_bn.substr(newObj.item_bn,-1)
          // let lastnum = newObj.item_bn.substr(newObj.item_bn.length - 1)
          // // alert(lastnum)
          // if(isNaN(parseFloat(lastnum))){
          //     // 非数字
          //     alert("填充货号最后一位必须是数字");
          //     return false;
          // }else {
          //     list.forEach(item => {
          //         Object.assign(item, newObj)
          //         item.item_bn = newObj.item_bn.slice(0,-1) +  (Number(lastnum) + Number(this.bulkFilling_index));
          //         this.bulkFilling_index ++ ;
          //     })
          //     store.dispatch('setPage', list)
          // }
      },
      clearSku(index) {
        this.$confirm('确定清除当前规格的数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let skuItem = this.specItems[this.currentPage-1][index]
          store.dispatch('removeSku', skuItem)
          for (let key in skuItem) {
            if (key !== 'item_spec') {
              if (key !== 'sku_id') {
                skuItem[key] = ''
              }
            }
          }
        })
      },
      closePicsDialog () {
        this.picsDialog = false
      },
      picsEnter (index) {
        this.picsCurrent  = index
      },
      picsLeave () {
        this.picsCurrent  = -1
      },
      removePicsImg: function (index) {
        this.form.pics.splice(index, 1)
        this.picsOldLen = this.form.pics.length
      },
      handleSkuChange() {
        this.updateSku()
      },
      updateSku() {
        let arr = []
        let skus = []
        this.skus.forEach(item => {
          if (item.checked_sku.length > 0) {
            arr.push(item)
          }
        })
        if (arr.length === 0) return
        let n = arr.findIndex(item => JSON.parse(item.is_image))
        if (n != -1) {
          let obj = {...arr[n]}
          let imgs = []
          let addedImg = this.specImages
          obj.checked_sku.forEach(item => {
            let added = addedImg.find(n => n.spec_value_id === item)
            let img = {
              spec_value_id: item,
              item_spec: this.getSkuName(item, obj.sku_value),
              item_image_url: added ? added.item_image_url : []
            }
            imgs.push(img)
          })
          this.specImages = imgs
          arr.splice(n, 1)
          arr.unshift(obj)
        }
        arr.forEach(item => {
          let skuGroup = []
          if (item.checked_sku.length > 0) {
            item.checked_sku.forEach(checked => {
              let issue = item.sku_value.find(sku => sku.attribute_value_id === checked)
              let obj = {
                spec_id: item.sku_id,
                spec_value_id: issue.attribute_value_id,
                spec_value_name: issue.attribute_value,
                spec_custom_value_name: issue.custom_attribute_value || ''
              }
              skuGroup.push(obj)
            })
            skus.push(skuGroup)
          }
        })
        let allSku = this.generateSkus(skus)
        if (this.skus.length > 1 && !allSku[0].length) {
          return false
        }
        let skuList = []
        allSku.forEach(item => {
          let obj = {
            is_default: false,
            sku_id: this.generateSkuids(item),
            item_spec: item.length ? item : [item],
            approve_status: '',
            store: '',
            item_bn: '',
            item_unit: '',
            weight: '',
            volume: '',
            price: '',
            cost_price: '',
            market_price: '',
            packing_fee: '',
            barcode: ''
          }
          skuList.push(obj)
        })
        if (this.editingSkus.length > 0) {
          this.editingSkus.forEach(item => {
            let in_item = skuList.find(n => item.sku_id === n.sku_id)
            if (!in_item) {
              store.dispatch('removeSku', item)
            }
          })
        }

        this.specTotal = skuList.length
        let list = []
        let len = Math.ceil(skuList.length / this.specPagesize)
        for (let i = 0; i < len; i++) {
          let childs = skuList.slice(i * this.specPagesize, i * this.specPagesize + this.specPagesize)
          list.push(childs)
        }
        if (this.editingSkus.length > 0) {
          list.forEach(item => {
            item.forEach(child => {
              let in_sku = this.editingSkus.find(editor => editor.sku_id === child.sku_id)
              if (in_sku) {
                Object.assign(child, in_sku)
              }
            })
          })
        }
        this.specItems = list
      },
      getSkuName(id, skus) {
        let sku = skus.find(item => id === item.attribute_value_id)
        if (sku) {
          return sku.attribute_value
        }
      },
      generateSkuids(data) {
        if (data.length) {
          let skuIds = []
          data.forEach(child => {
            skuIds.push(child.spec_value_id)
          })
          return skuIds.join('_')
        } else {
          return data.spec_value_id
        }
      },
      generateSkus(data) {
        let len = data.length
        if (len >= 2) {
            let len1 = data[0].length
            let len2 = data[1].length
            let newlen = len1 * len2
            let temp = new Array(newlen)
            let index = 0
            for ( let i = 0; i < len1; i++) {
                for (let j = 0; j < len2; j++) {
                    if (Array.isArray(data[0][i])) {
                        temp[index] = [...data[0][i], data[1][j]]
                    } else {
                        temp[index] = [data[0][i], data[1][j]]
                    }
                    index++
                }
            }
            let newArray = new Array(len-1)
            for (let i = 2; i < len; i++){
                newArray[i - 1] = data[i]
            }
            newArray[0] = temp
            return this.generateSkus(newArray)
        }
        else{
            return data[0]
        }
      },
      renderRequire (h,{column}) {
        return h(
          'span', {
            class:'mark'
          }, '*' + column.label
        )
      },
      handleContent (data) {
        this.content = data
      },
      deleteVideo() {
        this.itemVideo = {}
        this.form.videos = ''
        this.form.videos_url = ''
      },
      init () {
        getGoodsAttr({page: 1, pageSize: 500, attribute_type: 'brand'}).then(res => {
          for (let item of res.data.data.list) {
            this.brandList.push({attribute_name: item.attribute_name, attribute_id: item.attribute_id})
          }
        })

        getShippingTemplatesList(this.templatesListParams).then(response => {
          if (response.data.data.list.length > 0) {
            for(var i in response.data.data.list) {
              this.templatesList.push({
                'template_id': response.data.data.list[i].template_id,
                'name': response.data.data.list[i].name
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: '请先添加运费模板'
            })
            this.$router.push({path: this.matchInternalRoute('shippingtemplates')})
          }
        })

        getCategory({is_show:false}).then(response => {
          this.categoryList = response.data.data
        })
      }
    },
    beforeRouteLeave (to, from , next) {
      if (!this.isLeave) {
        this.$confirm('确定要离开当前页面，您将丢失已编辑的数据？！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then((res) => {
          store.dispatch('clearSkus')
          next()
        }).catch(() => {
          next(false)
        })
      } else {
        store.dispatch('clearSkus')
        next()
      }
    },
    mounted () {
      this.getItemsAttrLists();
      this.getItemsScopeLists();
      const _self = this
      async function onload () {
        if (_self.$route.query.is_new) {
          _self.is_new = _self.$route.query.is_new
        }
        await _self.init()
        if (_self.$route.params.itemId) {
          _self.isEditor = true
          _self.mainCateLoader = true
          // 初始化门店数据
          await getItemsDetail(_self.$route.params.itemId).then(response => {
            let itemsDetailData = response.data.data
            // 显示价格
            _self.distributors_prices_arr = itemsDetailData.distributors_prices_arr
            _self.only_show_price_high = itemsDetailData.only_show_price_high
            _self.only_show_price_low = itemsDetailData.only_show_price_low

            if (itemsDetailData.regions_id) {
              _self.select_regions_value = itemsDetailData.regions_id
            }
            _self.form.pics = itemsDetailData.pics
            // 处理图片列表
            var picList = []
            for (var item in itemsDetailData.pics) {
              var newpic = {}
              newpic.url = _self.wximageurl + itemsDetailData.pics[item]
              picList.push(newpic)
            }
            _self.picsList = picList
            let obj = _self.form
            _self.form = ({obj} = {
              item_id: _self.is_new ? '' : itemsDetailData.item_id,
              item_source: itemsDetailData.item_source,
              item_type: itemsDetailData.item_type,
              special_type: itemsDetailData.special_type,
              item_category: itemsDetailData.item_category.length > 0? itemsDetailData.item_category : [],
              item_name: itemsDetailData.item_name,
              common_name: itemsDetailData.common_name,
              sort: itemsDetailData.sort,
              item_bn: _self.is_new ? '' : itemsDetailData.item_bn,
              brief: itemsDetailData.brief,
              weight: itemsDetailData.weight*1000,
              volume: itemsDetailData.volume,
              price: itemsDetailData.price/100,
              market_price: itemsDetailData.market_price/100,
              cost_price: itemsDetailData.cost_price/100,
              packing_fee: itemsDetailData.packing_fee/100,
              barcode: itemsDetailData.barcode,
              item_unit: itemsDetailData.item_unit,
              rebate: itemsDetailData.rebate/100,
              store: itemsDetailData.store,
              brand_id: itemsDetailData.brand_id,
              templates_id: itemsDetailData.templates_id ? itemsDetailData.templates_id.toString() : '',
              express_templates_id: itemsDetailData.express_templates_id ? itemsDetailData.express_templates_id.toString() : '',
              approve_status: itemsDetailData.approve_status,
              pics: itemsDetailData.pics,
              producer: itemsDetailData.producer,
              Reg_No_: itemsDetailData.Reg_No_,
              unit_zhuan_huan_value: itemsDetailData.unit_zhuan_huan_value,
              spec: itemsDetailData.spec,
              videos: itemsDetailData.videos,
              videos_url: itemsDetailData.videos_url,
              nospec: itemsDetailData.nospec,
              is_show_specimg: itemsDetailData.is_show_specimg,
              item_params: itemsDetailData.item_params,
              item_main_cat_id: itemsDetailData.item_main_cat_id,
              is_settle_in:itemsDetailData.is_settle_in,
              is_NP_store:itemsDetailData.is_NP_store,
              is_apply:itemsDetailData.is_apply,
              is_yibao:itemsDetailData.is_yibao,
              is_settle_in_service:itemsDetailData.is_settle_in_service,
              si_charging_method:itemsDetailData.si_charging_method,
              si_rate:itemsDetailData.si_rate,
              si_fixed_costs:itemsDetailData.si_fixed_costs,
              keywords: itemsDetailData.keywords,
              items_attr:itemsDetailData.items_attr,
              items_scope:itemsDetailData.items_scope,
              vip_flag:itemsDetailData.vip_flag
            })
            console.log('itemsDetailDat-----------a', _self.form)
            // 修改前原价
            _self.originalPrice = _self.form.price
            _self.picsOldLen = _self.form.pics.length
            if (!itemsDetailData.item_main_cat_id) {
              _self.fetchMainCate()
            } else {
              let category = itemsDetailData.item_category_main
              if(category[0].children[0].children != undefined ){
                _self.categoryNames = [category[0].category_name, category[0].children[0].category_name, category[0].children[0].children[0].category_name]
              }else{
                 _self.categoryNames = [category[0].category_name, category[0].children[0].category_name]
              }
              _self.generateParams(itemsDetailData.item_params_list)
            }
            if (!_self.form.nospec) {
              _self.generateSpec(itemsDetailData.item_spec_list)
              _self.specImages = itemsDetailData.spec_images
              itemsDetailData.spec_items.forEach(item => {
                item.item_spec.forEach(child => {
                  let checkedIndex = _self.skus.findIndex(n => child.spec_id === n.sku_id)
                  let isin = _self.skus[checkedIndex].checked_sku.findIndex(k => child.spec_value_id === k)
                  if (isin === -1) {
                    _self.skus[checkedIndex].checked_sku.push(child.spec_value_id)
                  }
                })
              })

              itemsDetailData.spec_items.forEach(item => {
                let sku = Object.assign({}, item)
                sku.market_price = item.market_price/100
                sku.cost_price = item.cost_price/100
                sku.price = item.price/100
                sku.packing_fee = item.packing_fee/100
                sku.item_bn = _self.is_new ? '' : item.item_bn
                let itemId = []
                let specs = []
                item.item_spec.forEach(sub => {
                  specs.push({
                    spec_id: sub.spec_id,
                    spec_value_id: sub.spec_value_id,
                    spec_value_name: sub.spec_value_name,
                    spec_custom_value_name: sub.spec_custom_value_name || ''
                  })
                  itemId.push(sub.spec_value_id)
                })
                sku.item_spec = specs
                itemId = itemId.join('_')
                Object.assign(sku, {sku_id: itemId})
                store.dispatch('setSku', sku)
              })
              _self.updateSku()
            }
            if (typeof itemsDetailData.intro === 'object') {
              _self.mode = 'component'
              _self.content = itemsDetailData.intro
            } else {
              _self.form.intro = itemsDetailData.intro
            }
          })
          // .catch(error => {
          //   _self.$router.go(-1)
          // })
          _self.loader = false
          _self.itemVideo = {media_id:_self.form.videos, url:_self.form.videos_url}
          console.log('form------------', _self.form)

        } else {
          _self.fetchMainCate()
          _self.loader = false
        }
      }
      onload()
    }
  }
</script>
<style lang="scss">
  .vue-treeselect__placeholder{
    line-height: 40px;
  }
</style>
<style scoped lang="scss">
  .fallback-class {
    width: 118px;
    height: 118px;
  }
  .chosen-class {
    position: relative;
    height: 118px;
    text-align: center;
    .svg-icon {
      width: 26px;
      height: 26px;
    }
    &::after {
      position: absolute;
      top: 0;
      left: 118px;
      right: 118px;
      bottom: 0;
      background: #ffb28b;
      box-shadow: inset 0 0 0 2px #ff5000;
      content: "";
    }
  }
  .sku-value {
    margin-right: 10px;
  }
  .sku-img {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 5px;
    vertical-align: middle;
  }
  .sku-img-pick {
    color: #999;
    cursor: pointer;
  }
  .avatar-uploader-icon {
    font-size: 48px;
  }
  .sku-select__item {
    display: flex;
    position: relative;
  }
  .sku-select__checkgroup {
    padding-left: 20px;
    flex: 1;
  }
  .sku-select__checkitem {
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 20px;
  }
  .sku-remove__icon {
    position: absolute;
    width: 30px;
    height: 30px;
    top: -20px;
    right: -20px;
    background: #ff5000;
    line-height: 30px;
    text-align: center;
    color: #fff;
    font-size: 15px;
    cursor: pointer;
  }
  .sku-tip {
    padding-left: 10px;
    font-size: 12px;
    color: #999;
  }

  .pics-box {
    overflow: hidden;
    .goodspic-wrap {
      float: left;
      margin-right: 5px;
      overflow: hidden;
      .goodspic {
        position: relative;
        float: left;
        width: 120px;
        height: 120px;
        margin: 0 5px 10px;
        border: 1px solid #ddd;
        border-radius: 8px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
        .goodspic-mask {
          display: none;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,.2);
          cursor: pointer;
          &.on {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .iconfont {
            margin: 0 8px;
            font-size: 20px;
            color: #fff;
          }
        }
      }
    }

    .upload-box {
      display: inline-block;
      width: 120px;
      height: 120px;
      line-height: 120px;
      text-align: center;
      .iconfont {
        font-size: 30px;
        color: #ccc;
      }
    }
  }

  .tpl_item {
    display: inline-block;
    border: 1px solid #ddd;
    background-color: #fff;
    text-align: left;
    padding: 0 15px;
    line-height: 36px;
    cursor: pointer;
    border-radius: 3px;
    .iconfont {
      margin-right: 5px;
    }
  }

  .tpl_item .fa {
    width: 12px;
    height: 22px;
    vertical-align: middle;
    display: inline-block;
    margin-right: 1em;
    font-size: 20px;
    text-align: center;
  }

  .vue-html5-editor {
    vertical-align: top;
    display: inline-block;
  }

  .demo-ruleForm {
    .vue-html5-editor {
      width: 80%;
    }
  }
</style>



// WEBPACK FOOTER //
// add.vue?6afe2316